import React, { useEffect, useState } from "react";
import API_URL from "../../services/api";
import "./Librarians.css";

const Librarians = () => {
  const [librarians, setLibrarians] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tableLoading, setTableLoading] = useState(true);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [search, setSearch] = useState("");

  // ==============================
  // FETCH LIBRARIANS
  // ==============================

  const fetchLibrarians = async () => {
    try {
      setTableLoading(true);

      const res = await fetch(`${API_URL}/api/admin/librarians`);
      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.message || "Failed to fetch librarians");
      }

      setLibrarians(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error("Fetch librarians error:", err);
      alert("Unable to load librarians.");
    } finally {
      setTableLoading(false);
    }
  };

  useEffect(() => {
    fetchLibrarians();
  }, []);

  // ==============================
  // ADD LIBRARIAN
  // ==============================

  const addLibrarian = async () => {
    if (!name.trim() || !email.trim()) {
      alert("Please fill all fields.");
      return;
    }

    try {
      setLoading(true);

      const res = await fetch(
        `${API_URL}/api/admin/create-librarian`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            name: name.trim(),
            email: email.trim(),
          }),
        }
      );

      const data = await res.json();

      if (!res.ok) {
        alert(data.message || "Failed to create librarian.");
        return;
      }

      alert(
        `Librarian Created Successfully!\n\nEmail: ${data.credentials.email}\nPassword: ${data.credentials.password}`
      );

      setName("");
      setEmail("");

      await fetchLibrarians();
    } catch (err) {
      console.error("Add librarian error:", err);
      alert("Something went wrong while creating the librarian.");
    } finally {
      setLoading(false);
    }
  };

  // ==============================
  // SEARCH
  // ==============================

  const filteredLibrarians = librarians.filter((lib) => {
    const searchText = search.toLowerCase();

    return (
      lib.user_id?.toString().toLowerCase().includes(searchText) ||
      lib.name?.toLowerCase().includes(searchText) ||
      lib.email?.toLowerCase().includes(searchText)
    );
  });

  // ==============================
  // RETURN
  // ==============================

  return (
    <div className="librarians-container">

      {/* PAGE HEADER */}
      <div className="librarians-header">
        <div>
          <h1>Librarians</h1>
          <p>Manage librarian accounts and access.</p>
        </div>

        <div className="librarian-count">
          Total: <strong>{librarians.length}</strong>
        </div>
      </div>

      {/* ADD LIBRARIAN FORM */}
      <div className="librarian-form-card">

        <h2>Create Librarian Account</h2>

        <div className="librarian-form">

          <div className="form-group">
            <label>Librarian Name</label>

            <input
              type="text"
              placeholder="Enter librarian name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label>Email Address</label>

            <input
              type="email"
              placeholder="Enter librarian email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <button
            className="add-librarian-btn"
            onClick={addLibrarian}
            disabled={loading}
          >
            {loading ? "Creating..." : "＋ Add Librarian"}
          </button>

        </div>

        <p className="form-note">
          A login password will be generated automatically after the
          librarian account is created.
        </p>
      </div>

      {/* SEARCH */}
      <div className="librarian-toolbar">

        <input
          type="text"
          className="librarian-search"
          placeholder="Search by ID, name or email..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

      </div>

      {/* TABLE */}
      <div className="librarian-table-card">

        <div className="table-title">
          <h2>Librarian Accounts</h2>

          <span>
            {filteredLibrarians.length} record
            {filteredLibrarians.length !== 1 ? "s" : ""}
          </span>
        </div>

        {tableLoading ? (
          <div className="table-message">
            Loading librarians...
          </div>
        ) : filteredLibrarians.length === 0 ? (
          <div className="table-message">
            No librarians found.
          </div>
        ) : (
          <div className="table-wrapper">

            <table className="librarian-table">

              <thead>
                <tr>
                  <th>User ID</th>
                  <th>Name</th>
                  <th>Email</th>
                </tr>
              </thead>

              <tbody>

                {filteredLibrarians.map((lib) => (
                  <tr key={lib.id}>

                    <td>
                      <span className="user-id">
                        {lib.user_id}
                      </span>
                    </td>

                    <td>
                      {lib.name}
                    </td>

                    <td>
                      {lib.email}
                    </td>

                  </tr>
                ))}

              </tbody>

            </table>

          </div>
        )}

      </div>

    </div>
  );
};

export default Librarians;
